import type { SITE_PUSH_BUTTON_EVENTS_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-push-button-events-card/site-push-button-events-card.fr.ts";

export const SITE_PUSH_BUTTON_EVENTS_CARD_ENGLISH_LOCALE = {
  title: "Push button",
  lastPush: "Last push",
  count: "Push count last 72h",
} satisfies typeof SITE_PUSH_BUTTON_EVENTS_CARD_FRENCH_LOCALE;
